import React, { useEffect, useState } from "react";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Card, CardBody, Col, Input, Row } from "reactstrap";
import { Triangle } from "react-loader-spinner";
import ComplimentryService from "../../../Services/QRCodeServices/ComplimentryService/ComplimentryService";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { Link } from "react-router-dom";
import { formatDateTime } from "../../../Components/Common/FormatDate";

const ComplimentryGroupItem = () => {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalData: 0,
  });
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);

  // filters
  const [dateRange, setDateRange] = useState([null, null]);
  const [filterText, setFilterText] = useState("");
  const formatDate = (date) => {
    if (!date) return null;
    return date.toLocaleDateString("en-CA"); // en-CA gives YYYY-MM-DD
  };

  const fetchData = async (page = 1, pageSize = pagination?.pageSize) => {
    setLoading(true);
    try {
      const response = await ComplimentryService.getGrpItem({
        page,
        pageSize,
        startDate: formatDate(dateRange[0]),
        endDate: formatDate(dateRange[1]),
      });

      if (response) {
        setAllData(response);
        setPagination({
          currentPage: response.currentPage,
          pageSize: response.pageSize,
          totalPages: response.totalPages,
          totalData: response.totalData,
        });
      } else {
        setAllData([]);
        setPagination((prev) => ({ ...prev, totalData: 0 }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  // fetch when filters change
  useEffect(() => {
    fetchData(1);
  }, [dateRange, filterText]);

  // columns
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      width: "75px",
    },
    {
      name: "Product Name",
      selector: (row) => row.productName,
      sortable: true,
    },

    {
      name: "Total Count",
      selector: (row) => row.totalComplimentryCount,
      sortable: true,
      right: true,
    },
    {
      name: "Total Value",
      selector: (row) => row.totalComplimentryValue,
      sortable: true,
      right: true,
    },
  ];

  return (
    <>
      <Card>
        <CardBody>
          {/* Filters */}
          <Row className="mb-3">
            <Col md={4}>
              <Flatpickr
                options={{ mode: "range", dateFormat: "Y-m-d" }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                className="form-control"
                placeholder="Select date range"
              />
            </Col>
            <Col md={4}>
              <Input
                type="text"
                placeholder="Search..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
          </Row>

          {/* Table */}
          <CustomDataTable
            responsive
            striped
            pagination
            paginationServer
            paginationTotalRows={pagination.totalData}
            paginationDefaultPage={pagination.currentPage}
            onChangePage={(page) => fetchData(page)}
            onChangeRowsPerPage={(newPageSize) => fetchData(1, newPageSize)}
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={{
              headCells: {
                style: {
                  fontSize: "0.93rem",
                  fontWeight: 610,
                },
              },
              rows: {
                style: {
                  fontSize: "0.9rem",
                },
              },
            }}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={allData}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default ComplimentryGroupItem;
